/*

Sohel 11/28/2022 3031450488  search table Payload changes
Ashraf 11/29/2022 3031450488 Added edit icon for editing
Saikrishna  11/29/2022  3031450488 Added field type conditionally for data repository section.
Ashraf 11/29/2022 3031450488 removed editable link
Ashraf 11/29/2022 3031450488 changed payload for download usage
Ashraf 11/29/2022 3031450488 disabled edit and delete for system repo's
Sohel 11/30/2022 3031450488 field name values changes
Ashraf 11/30/2022 3031450488 removed deleting field icon
Poornima 12/01/2022 2698947782 fixed usage popup bug
Prakash 12/01/2022 2698947782 fixed Table word wrap issues.
Poornima 12/01/2022 2698947782 fixed usage component issue
Sai maheshwar 12/02/2022 3031450488 added AND/OR condition for rule builder.
Sai krishna 12/02/2022 3031450488 Fixed deleted ids bugs.
Sohel 12/02/2022 3031450488 Global Field List Changes
Sai maheshwar 12/02/2022 3031450488 fixed AND/OR condition issue rule builder.
Sohel 12/03/2022 3031450488 Global Field List deleted bugs.
Sai Maheshwar 12/03/2022 3031450488 added save and close in map fields
Sai Maheshwar 12/04/2022 2698948956 Added map fields save close buttons
Sohel 12/04/2022 3031450488 Account Update Group Changes
// Saikrishna 4/12/2022 3031450488 Added check box disable condition for work queues and global field lists.
Sai Maheshwar 12/05/2022 3031450488 added map fields save and close
Dilip 12/05/2022  3031450488 Removed unecesarry console.log statements
lalitha 12/07/2022 3031450488 added Created By payload
// Saikrishna 12/08/2022 2698947782  System notes for data repo is added in popup of actions
akhila 12/08/2022 3031450488  adding session storage for search items
kavya9reddy 12/09/2022 3031450488 Added createdDate in  payload
akhila 12/12/2022 3031450488 changed api for RepositoryFields Usage
akhila 12/14/2022 3031450488 adding formula fields for formula table
akhila 12/15/2022 3031450488  adding Filter Fields for filter table
kavyareddy 12/23/2022 3031450488 fixed word break issue in description.
Raghu 12/26/2022 3031450488 Added Dialog Component
lalitha 12/26/2022 3031450488 changed the possition of Repository Description column
Suresh Peddavoora 12/27/2022 3031450488 Fixed Data overlapping issue in map fields
Ashraf 01/02/2022 3031450488 renamed usage header title
saikrishna 01/04/2023 3031450488  add createdby and created date to payload
Sohel 01/10/2023 2698964415 Added disable conditions.
Sohel 01/10/2023 2698964415 Added disable conditions in Fields.
Sohel 01/13/2023 2698964415 Field Type Value Changes
Sohel 01/16/2023 2698964415 fixed dataType Issue
Ashraf 01/16/2023 2698964415 fixed single select issue
Sohel 01/17/2023 2698959212 fields changes
Akhila 01/17/2023 3031450488 fixed category issue in data calculation select field table
saikrishna 01/20/2023 3031450488 added createddate and createdaby in payload
Sohel 01/23/2023 2698964415 Added Audit Fields table
Sohel 01/23/2023 2698964415 disabled fields
Ashraf 01/31/2023 2698964415 disable select options for export Manager
Rohini 02/09/2023 2698964415 added classnames for table
Sohel 02/13/2022 2698947782 fixed button disabled issue
Dilip 02/13/2023 2698964415 created by , creted for payload changes
Sohel 02/21/2023 2698964415 Audit Field List Changes
Ravi 02//23/2023 2698964415 Added popup in download configuration button.
Fahaduddin 02/28/2023 2698964415 fixed sorting issues.
T Santosh Kumar 15/03/2023 2698964415 Responsive UI Changes
Raghu 03/16/2023 2698964415 action table fixed
Dilip 03/17/2023 2698964415 Fixed session storage issue
Sohel 03/22/2023 2698964415 Letter Field Payload Changes
Akhila 03/28/2023 2698964415 bug fix reusable in account update
Sohel 03/29/2023 2698964415 Fixed prepopulate category and repository Type
Sohel 03/30/2023 2698964415 populate Field Name
Raghu 03/04/2023 2698964415 added plus icon
suresh peddavoora 04/06/2023 2698964415 field alignments fixes
Sohel 04/14/2023 2701335619 Added Map Field Fields FOr Exception Type
Ravi 05/31/2023 2698964415 changed delete popup message
Akhila 06/07/2023 2698964415 added code and description in action
Akhila 06/08/2023 2698964415 created date change to date created field and column
sohel 09/24/2023 5155351299 payload modification new fields added
Sohel 09/24/2023 5155351299 Reset Base Repository Fields Data
Sohel 09/26/2023 5155351299 Company lookup data change and integerated
Sohel 09/27/2023 5155351299 Search Table Payload Changes.
Sohel 09/27/2023 5155351299 Pass Field USage based on Condition  in Payload
Sohel 09/29/2023 5155351299 Remove Field Usage and Company in Search Table.
Sohel 09/29/2023 5155351299 Added Field Type in Payload
Sohel 10/01/2023 5155351299 Removed Company and Field Usage Field
Sohel 10/02/2023 4136387705 FieldType Payload Changes
Sohel 10/03/2023 5155351299 Search Payload Changes
Sohel 10/04/2023 5155351299 download configuration payload changes
Sohel 06/10/2023 5155351299 download configuration usage payload added
Sohel 10/10/2023 5155351299 Fixed Event Trigger DbColumn Name Issue
Uday 16/10/2023 5155351299 Fixed table scroll issues
Sohel 12/10/2023 5155351299 bug fixed reset issue when extra space searching
*/

import { Button, Grid, TablePagination } from '@material-ui/core';
// import MaterialTable from "material-table";
import React, { createRef, useEffect, useState, useContext, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { tableIcons } from '../../../../../components/TableIcons';
import { defaultRows } from '../../../../../constants/ReusableTablePagination';
import {
  fetchDataRepository,
  printDataRepositories,
  resetDataRepo,
  fetchDataRepoUsage,
  resetBaseRepositoryFields,
} from '../../../../../redux/reducers/GlobalField/DataRepository';
import { httpPaginationDelete, httpPaginationPost } from '../../../../../util/Rest';
import { resetMessage } from '../../../../../redux/reducers/GlobalField/AddFieldList';
import {
  resetMsg,
  resetConfigUrl,
  resetDockey,
} from '../../../../../redux/reducers/GlobalField/DataRepository';
import {
  SuccessSnackbar,
  ErrorSnackbar,
  WarningSnackbar,
} from '../../../../../components/CustomSnackBar';
import { postPrintUsage, resetPrintUsageData } from '../../../../../redux/reducers/printUsage';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import { useUpdateEffect } from 'react-use';
import OverrideRule from '../../../../../components/OverrideRule';
import SelectTabContextProvider from '../../../../../components/SelectTabContext/SelectTabContext';
import { makeStyles } from '@material-ui/core';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import { tablePageRows } from '../../../../../constants/ReusableConstants';
import UsageMessage from '../../../../../util/UsageMessage';
import { getFields } from '../../../Reports/AddReport/Components/utils';
import moment from 'moment';
import DataRepositorySystemNotes from '../AddDataRepositories/DataRepositorySystemNotes';
import { DATA_REPOSITORY } from '../../../../../constants/ReusableRoleAccess';
import DialogBox from '../../../../../components/DialogBox';
import { downloadButton } from '../../../../../util/Content';
import { fetchCreatedByDropDownData } from '../../../../../redux/reducers/ReportMaster';
import PreviewFileDialog from '../../../../../util/PreviewFileDialog';
import axios from 'axios';
import PageLoader from '../../../../../components/PageLoader';
import SaveIcon from '@material-ui/icons/Save';
import ActionMenuItem from '../../../../../util/ActionMenuItem';
import { MTableToolbar } from 'material-table';
import AddIcon from '@material-ui/icons/AddOutlined';
const fieldUsage = ['IMPORT', 'TRIGGER', 'WORK_QUEUE', 'REPORT', 'EXPORT'];
const FieldListSearchTable = ({
  eventTrigger,
  searchData,
  setTabValue,
  submit,
  setSubmit,
  setFieldListRowData,
  setUsage,
  usage,
  isDelete,
  setIsDelete,
  userMetrixDelete,
  setUsageState,
  usageState,
  setRowSelected,
  setUserMetrixDelete,
  setIsCopyData,
  StepperFieldList,
  setShowSearch,
  setFieldListCode,
  setFieldList,
  fieldList,
  isReportLoader,
  deleteSql,
  isReports,
  isReportsFilter,
  rules = [],
  sortFields = [],
  setSortFields,
  selectedRows = [],
  setFieldValue,
  setSelectedRows,
  isGlobalFieldList,
  resultExpCondition,
  reportFieldsDeleteIdsRef,
  sortFieldsDeleteIdsRef,
  resultRef,
  values,
  fieldsDeleteIdsRef,
  tempSelectedRows = [],
  setTempSelectedRows,
  tempUnCheckedRef,
  addAccountUpdate,
  setSelectedGlobalField,
  handleEventTacticSearch,
  mapFields,
  workQueue,
  setFormulaFields,
  formulaFields,
  setFilterFields,
  filterFields,
  isDataManager,
  dmValues,
  isDMRTrue,
  setIntermediateField,
  intermediateField,
  handleSelectTriggerField,
  saveData,
  setSaveData,
  selectedRepoField,
  setSelectedField,
  isFormulaTrue,
  isDMTrue,
  isLetterMaintenance,
  exceptionType,
  isDMFilter,
  setDateStampFields,
  dateStampFields,
  reportDateStamp,
  moduleName,
}) => {
  const tableRef = createRef();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const maxSelections = 1;
  const handleSelectionProps = (rowData) => {
    return {
      disabled:
        (eventTrigger &&
          saveData &&
          saveData?.length >= maxSelections &&
          !rowData.tableData.checked) ||
        (setIntermediateField &&
          tempSelectedRows?.length >= maxSelections &&
          !rowData.tableData.checked),
    };
  };
  const [rows, setRows] = useState(defaultRows);

  const [deleteData, setDeleteData] = useState({});
  const [tstmsg, setToastMsg] = useState('');
  const [status, setStatus] = useState(false);
  const [dataCount, setDataCount] = useState('');
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const { setGlobalFieldRow } = useContext(SelectTabContextProvider);
  const [configOpen, setConfigOpen] = useState(false);
  const [isLoadingPrint, setIsLoadingPrint] = useState(false);
  const [configData, setConfigData] = useState(null);
  const printusage = useSelector(({ printusage }) => printusage);
  const { roleData } = useSelector(({ role }) => role);
  const dataRepoAccess = roleData?.window?.[DATA_REPOSITORY]?.['DR'];
  // const [order, setOrder] = useState({});
  const order = {};
  const [customError, setCustomError] = useState(false);
  const [deleteUsage, setDeleteUsage] = useState(false);
  const [isNote, setIsNote] = useState(false);
  const [dataRepoRowData, setDataRepoRowData] = useState(false);
  const { basicInfoData } = useSelector(({ addRuleGroup }) => addRuleGroup);
  const {
    DataRepoPrintStatus,
    successMsg,
    errorMsg,
    isLoading,
    dataRepoUsage,
    configurationUrl,
    dockey,
  } = useSelector(({ dataRepository }) => dataRepository);
  const queryRef = useRef(null);
  const companyData = JSON.parse(sessionStorage.getItem('companyName'));
  companyData?.unshift('ALL');
  const useStyles = makeStyles((theme) => ({
    link: {
      // Changed field list code column font color (2700799562)
      color: '#320469 !important',
      textAlign: 'justify',
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      borderBottom: '1px solid #000099',
    },
    ' & .MuiSvgIcon-root': {
      backgroundColor: '#320469 !important',
    },
  }));
  const classes1 = useStyles();

  useEffect(() => {
    if (setTempSelectedRows) {
      if (intermediateField && 'fieldName' in intermediateField) {
        setTempSelectedRows([intermediateField]);
      } else {
        setTempSelectedRows([]);
      }
      tempUnCheckedRef.current = [];
    }
    dispatch(resetBaseRepositoryFields());
  }, []);
  useEffect(() => {
    if (configurationUrl) {
      setIsLoadingPrint(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingPrint(false);
      }
      readData();
    }
  }, [configurationUrl]);
  useEffect(() => {
    if (dataRepoUsage?.userMetrix === 'No') {
      deleteUsage ? setUserMetrixDelete(false) : setCustomError(true);
      deleteUsage && setIsDelete(true);
      setTimeout(() => {
        setCustomError(false);
        dispatch(resetDataRepo());
      }, 3000);
    } else if (dataRepoUsage?.userMetrix === 'Yes') {
      deleteUsage && setIsDelete(true);
      deleteUsage && setUserMetrixDelete(true);
      !deleteUsage && setUsage(true);
      !deleteUsage && setTabValue(2);
    }
  }, [dataRepoUsage]);

  useEffect(() => {
    if (DataRepoPrintStatus === 200 && successMsg) {
      setTimeout(() => {
        dispatch(resetDataRepo());
        setTabValue(0);
      }, 3000);
    }
  }, [DataRepoPrintStatus, successMsg]);

  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  const handleNotes = (rowData) => {
    setDataRepoRowData(rowData);
    setIsNote(true);
  };
  const handleEdit = (rowData) => {
    if (rowData?.dataRepositoryId) {
      dispatch(fetchDataRepository(rowData?.dataRepositoryId));
      setRowSelected(rowData?.dataRepositoryId);
      if (!StepperFieldList) {
        setTabValue(1);
        setGlobalFieldRow(true);
      } else {
        setShowSearch(true);
      }
    }
  };
  const handleUsage = (rowData) => {
    setDeleteUsage(false);
    dispatch(fetchDataRepoUsage(rowData, 'RepoField'));
    setFieldListRowData(rowData);
  };

  // if table data print successfully or error message then reset message after 3sec.(2700799562)
  useEffect(() => {
    if (printusage.errorMsg || printusage.successMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printusage.errorMsg, printusage.successMsg]);

  useEffect(() => {
    if (successMsg) {
      tableRef.current.onQueryChange();
    }
  }, [successMsg]);

  // delete data reset error or sucess toast message after 2.5sec(2700799562)
  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 2500);
    }
  }, [tstmsg, deleteErrorMsg]);

  // if Usage then reset Usage State(2700799562)
  useEffect(() => {
    usageState && setUsageState(false);
    setUsage(false);
  }, []);
  const handleDelete = (rowData) => {
    setDeleteData(rowData);
    dispatch(fetchDataRepoUsage(rowData?.dataRepositoryId));
    setIsDelete(false);
    setDeleteUsage(true);
    setUsage(false);
    // dispatch(deleteRepository(rowData?.dataRepositoryId));
    // setIsDelete(true);
    // setDeleteUsage(true);
  };

  const handleCloseDialog = () => {
    setIsDelete(false);
    setIsNote(false);
    setTimeout(() => {
      setUserMetrixDelete(false);
    }, 1000);
  };
  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
  };

  // status is changed Update Table Data(2700799562)
  useUpdateEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      dispatch(fetchCreatedByDropDownData('datarepository'));
      setStatus(false);
    }
  }, [status]);

  // delete Global Field List(2700799562)
  const handleSubmit = () => {
    setStatus(true);
    httpPaginationDelete(`data-repository/delete/data-repository/${deleteData?.dataRepositoryId}`)
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setToastMsg(response?.response);
          setStatus(false);
          // dispatch(fetchSuccess(response));
          handleCloseDialog();
          setTimeout(() => {
            dispatch(resetMessage());
          }, 6000);
        } else {
          setDeleteErrorMsg(response?.data?.message);
          setStatus(false);
          handleCloseDialog();
          setTimeout(() => {
            dispatch(resetMessage());
          }, 6000);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // checking when delete there is usage or not(2700799562)
  const handleDeleteUsage = () => {
    if (isDelete && userMetrixDelete) {
      // setFieldListRowData(deleteData);
      setUsage(true);
      setIsDelete(false);
      setTimeout(() => {
        setUserMetrixDelete(false);
      }, 1000);

      // setTabValue(2);
    } else {
      handleSubmit();
    }
  };
  const columns = [
    {
      title: 'Category',
      field: 'category',
      maxWidth: '80px',
      render: (rowData) => (
        <>
          <div
            style={{
              textAlign: 'left',
            }}
          >
            {rowData?.category === 'CL'
              ? 'CL - Client'
              : rowData?.category === 'CO'
                ? 'CO - Core'
                : rowData?.category === 'PA'
                  ? 'PA - Payment'
                  : ''}
          </div>
        </>
      ),
    },

    {
      title: 'Repository Name',
      field: 'repositoryName',
      cellStyle: {
        maxWidth: 250,
        minWidth: 250,
      },
      render: (rowData) =>
        isReports ? (
          <div className="table-word-wrap">{rowData?.repositoryName?.replace(/ /g, '\u00a0')}</div>
        ) : (
          <span
            role="button"
            className={` ${classes1.link}`}
            onClick={() => {
              if (rowData?.dataRepositoryId) {
                dispatch(fetchDataRepository(rowData?.dataRepositoryId));
                setRowSelected && setRowSelected(rowData?.dataRepositoryId);
                if (!StepperFieldList) {
                  setTabValue(1);
                  setGlobalFieldRow(true);
                } else {
                  setShowSearch && setShowSearch(true);
                }
              }
              handleSelectTriggerField && handleSelectTriggerField(rowData);
            }}
          >
            {rowData?.repositoryName.replace(/ /g, '\u00a0')}
          </span>
        ),
    },
    {
      title: 'Repository Description',
      field: 'repositoryDescription',
      maxWidth: 200,
      render: (rowData) => (
        <>
          <div className="table-word-wrap">
            {rowData.repositoryDescription.replace(/ /g, '\u00a0')}{' '}
          </div>
        </>
      ),
    },
    {
      title: 'Field Name',
      field: 'fieldName',
      cellStyle: {
        maxWidth: 250,
        minWidth: 250,
      },
      render: (rowData) => (
        <>
          <div className="table-word-wrap">{rowData?.fieldName} </div>
        </>
      ),
    },
    {
      title: 'Field Description',
      field: 'fieldDescription',
      cellStyle: {
        maxWidth: 200,
        minWidth: 200,
      },
      render: (rowData) => (
        <>
          <div className="table-word-wrap">{rowData?.fieldDescription} </div>
        </>
      ),
    },

    {
      title: 'Field Type',
      field: 'fieldType',
      maxWidth: '85px',
      hidden: !isReports,
    },
  ];

  if (!workQueue) {
    columns.push({
      title: 'Created By',
      field: 'createdBy',
      maxWidth: 100,
    });

    columns.push({
      title: 'Date Created',
      field: 'createdDate',
      maxWidth: 90,
      render: (rowData) => {
        return rowData?.createdDate ? moment(rowData?.createdDate).format('MM/DD/YYYY') : '';
      },
    });
  }

  const SearchSessionRepository = JSON.parse(sessionStorage.getItem('Repository'));
  if (SearchSessionRepository && !submit && !mapFields && !addAccountUpdate) {
    searchData = SearchSessionRepository;
  }

  return (
    <>
      {isLoading || (
        <DeleteTableRecordPopup
          open={isDelete}
          dialogClose={handleCloseDialog}
          title="Delete Data Repository"
          value={
            userMetrixDelete ? (
              <UsageMessage value={'Data Repository'} />
            ) : (
              `Are you sure you want to delete the ${deleteData?.repositoryName} Data Repository ?`
            )
          }
          handleSubmit={handleDeleteUsage}
          buttonCondition={userMetrixDelete}
        />
      )}
      <DialogBox
        open={isNote}
        dialogClose={handleCloseDialog}
        title="Data Repository Notes"
        maxWidth="lg"
      >
        <DataRepositorySystemNotes
          // dataRepoRowData={dataRepoRowData}
          filedListCode={dataRepoRowData}
        />
      </DialogBox>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Data Repository'}
      />
      <OverrideRule
        dialogTitle="Data Repository Usage"
        dialogOpen={usage}
        dialogClose={() => setUsage((state) => !state)}
        title={`This Data Repository has been used in the following places.`}
        data={dataRepoUsage?.placeResponse}
        type={'Data Repository'}
        isOverRide={false}
      />
      <Grid item xs={12}>
        <div className="custom-table  custom-toolbar-icons custom-actions-icon  global-field-table new-standard-textfields actions-dropdown-table tablescroll-block">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            onSelectionChange={(rows, row) => {
              eventTrigger && setSaveData && setSaveData(rows);
              if (row?.tableData?.checked) {
                if ((setFormulaFields && formulaFields) || setIntermediateField) {
                  if (tempSelectedRows) {
                    const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                    arr.push({
                      ...row,
                      tableData: { ...row.tableData, id: row.fieldName + row.repositoryName },
                    });
                    setTempSelectedRows(arr);
                  }
                }
                if (setFilterFields && filterFields) {
                  if (tempSelectedRows) {
                    const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                    arr.push({
                      ...row,
                      tableData: { ...row.tableData, id: row.fieldName + row.repositoryName },
                    });
                    setTempSelectedRows(arr);
                  }
                }
                if (isLetterMaintenance) {
                  if (tempSelectedRows) {
                    const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                    arr.push({
                      ...row,
                      letterFieldName: row?.fieldName,
                      tableData: { ...row.tableData, id: row.fieldName + row.repositoryName },
                    });
                    setTempSelectedRows(arr);
                  }
                }
                if (setSelectedRows && selectedRows) {
                  if (tempSelectedRows) {
                    const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                    arr.push({
                      ...row,
                      tableData: { ...row.tableData, id: row.fieldName + row.repositoryName },
                      ...(!isReportsFilter && getFields(row)),
                      processorFieldType: 'DB Field',
                      dataType: row.fieldType,
                      dbColumnName: row.tableColumnName,
                    });
                    setTempSelectedRows(arr);
                  }
                }
                if (isDMRTrue) {
                  if (tempSelectedRows) {
                    const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                    arr.push({
                      ...row,
                      tableData: { ...row.tableData, id: row.fieldName + row.repositoryName },
                      processorFieldType: 'DB Field',
                      dataType: row.fieldType,
                    });
                    setTempSelectedRows(arr);
                  }
                }
                if (isDataManager) {
                  if (tempSelectedRows) {
                    const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                    arr.push({
                      ...row,
                      tableData: { ...row.tableData, id: row.fieldName + row.repositoryName },
                      mapFieldType: 'DB Field',
                      fieldHeader: row.fieldName,
                      fieldPosition: '',
                      startPosition: '',
                      fieldLength: '',
                      format: '',
                      dataType: row.fieldType,
                    });
                    setTempSelectedRows(arr);
                  }
                }
                if (rules && isReportsFilter) {
                  if (row?.tableData?.checked) {
                    const arr = [...tempSelectedRows];
                    arr.push({
                      ...row,
                      tableData: { ...row.tableData, id: row.fieldName + row.repositoryName },
                    });
                    setTempSelectedRows(arr);
                  }
                }

                if (setSortFields && tempSelectedRows) {
                  const dataObj = {
                    seqNum: '',
                    sortOrder: 'N',
                    printTotal: 'N',
                  };
                  setTempSelectedRows([
                    ...tempSelectedRows,
                    {
                      ...row,
                      tableData: { ...row.tableData, id: row.fieldName + row.repositoryName },
                      ...dataObj,
                    },
                  ]);
                }
                if (setDateStampFields && tempSelectedRows) {
                  const dataObj = {
                    seqNum: '',
                    dateValue: '',
                  };
                  setTempSelectedRows([
                    ...tempSelectedRows,
                    {
                      ...row,
                      tableData: { ...row.tableData, id: row.fieldName + row.repositoryName },
                      ...dataObj,
                    },
                  ]);
                }
              } else {
                if (
                  (setSelectedRows && setTempSelectedRows) ||
                  setIntermediateField ||
                  isLetterMaintenance
                ) {
                  tempUnCheckedRef.current.push(row);
                  const updatedRows = [...tempSelectedRows]
                    .filter(
                      (ele) =>
                        ele?.fieldName + ele?.repositoryName !==
                        row?.fieldName + row?.repositoryName,
                    )
                    .map((ele) => {
                      return {
                        ...ele,
                        tableData: { ...ele.tableData, id: ele.fieldName + ele?.repositoryName },
                      };
                    });
                  setTempSelectedRows(updatedRows);
                }
                if (isDataManager) {
                  tempUnCheckedRef.current.push(row);
                  const updatedRows = [...tempSelectedRows]
                    .filter(
                      (ele) =>
                        ele?.fieldName + ele?.repositoryName + ele?.mapFieldType !==
                        row?.fieldName + row?.repositoryName + row?.mapFieldType,
                    )
                    .map((ele) => {
                      return {
                        ...ele,
                        tableData: { ...ele.tableData, id: ele.fieldName + ele?.repositoryName },
                      };
                    });
                  setTempSelectedRows(updatedRows);
                }
                if (isDMRTrue) {
                  tempUnCheckedRef.current.push(row);
                  const updatedRows = [...tempSelectedRows]
                    .filter(
                      (ele) =>
                        ele?.fieldName + ele?.repositoryName + ele?.processorFieldType !==
                        row?.fieldName + row?.repositoryName + row?.processorFieldType,
                    )
                    .map((ele) => {
                      return {
                        ...ele,
                        tableData: { ...ele.tableData, id: ele.fieldName + ele?.repositoryName },
                      };
                    });
                  setTempSelectedRows(updatedRows);
                }
                if (setFormulaFields && formulaFields) {
                  tempUnCheckedRef.current.push(row);
                  const updatedRows = [...tempSelectedRows]
                    .filter(
                      (ele) =>
                        ele?.fieldName + ele?.repositoryName !==
                        row?.fieldName + row?.repositoryName,
                    )
                    .map((ele) => {
                      return {
                        ...ele,
                        tableData: { ...ele.tableData, id: ele.fieldName + ele?.repositoryName },
                      };
                    });
                  setTempSelectedRows(updatedRows);
                }
                if (setFilterFields && filterFields) {
                  tempUnCheckedRef.current.push(row);
                  const updatedRows = [...tempSelectedRows]
                    .filter(
                      (ele) =>
                        ele?.fieldName + ele?.repositoryName !==
                        row?.fieldName + row?.repositoryName,
                    )
                    .map((ele) => {
                      return {
                        ...ele,
                        tableData: { ...ele.tableData, id: ele.fieldName + ele?.repositoryName },
                      };
                    });
                  setTempSelectedRows(updatedRows);
                }

                if (setSortFields) {
                  tempUnCheckedRef.current.push(row);
                  const updatedRows = [...tempSelectedRows]
                    .filter(
                      (ele) =>
                        ele?.fieldName + ele.repositoryName !== row?.fieldName + row.repositoryName,
                    )
                    .map((ele) => {
                      return {
                        ...ele,
                        tableData: { ...ele.tableData, id: ele.fieldName + ele.repositoryName },
                      };
                    });
                  setTempSelectedRows(updatedRows);
                }
                if (setDateStampFields) {
                  tempUnCheckedRef.current.push(row);
                  const updatedRows = [...tempSelectedRows]
                    .filter(
                      (ele) =>
                        ele?.fieldName + ele.repositoryName !== row?.fieldName + row.repositoryName,
                    )
                    .map((ele) => {
                      return {
                        ...ele,
                        tableData: { ...ele.tableData, id: ele.fieldName + ele.repositoryName },
                      };
                    });
                  setTempSelectedRows(updatedRows);
                }
                if (rules && isReportsFilter) {
                  const updatedRows = [...tempSelectedRows]
                    .filter(
                      (ele) =>
                        ele?.fieldName + ele.repositoryName !== row?.fieldName + row.repositoryName,
                    )
                    .map((ele) => {
                      return {
                        ...ele,
                        tableData: { ...ele.tableData, id: ele.fieldName + ele.repositoryName },
                      };
                    });
                  setTempSelectedRows(updatedRows);
                }
              }
            }}
            isLoading={isLoading || isReportLoader || printusage?.isLoading}
            data={(query) =>
              new Promise((resolve) => {
                const url = `data-repository/search/data-repository-field`;
                const bodyObj = {
                  category:
                    eventTrigger || isDMFilter || addAccountUpdate
                      ? 'CO'
                      : !eventTrigger && searchData?.category?.categoryCode
                        ? searchData.category?.categoryCode
                        : '',
                  fieldName: searchData?.fieldName ? searchData.fieldName : '',
                  fieldDescription: searchData?.fieldDescription ? searchData.fieldDescription : '',
                  repositoryName: searchData?.repoName ? searchData.repoName : '',
                  repositoryDescription: searchData?.repoDescription
                    ? searchData.repoDescription
                    : '',
                  fieldType: isReports && searchData?.fieldType ? searchData?.fieldType : '',
                  companyList: companyData.length > 0 ? companyData : [],
                  fieldUsage: moduleName ? [moduleName] : fieldUsage,
                  limit: query.pageSize ? query.pageSize : null,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  createdBy: searchData?.createdBy?.userLoginName
                    ? searchData?.createdBy?.userLoginName
                    : '',
                  createdDate: searchData?.createdDate
                    ? moment(searchData?.createdDate).format('MM/DD/YYYY')
                    : '',
                  page: submit
                    ? 1
                    : arrayLast && query.page >= 1
                      ? query.page
                      : arrayLast
                        ? (query.page <= 1 && query.page + 1) || query.page - 1
                        : query.page + 1,
                };
                if (isFormulaTrue) {
                  bodyObj.category = basicInfoData?.category;
                }
                if (reportDateStamp) {
                  bodyObj.category = 'CO';
                  bodyObj.fieldType = 'Date';
                }
                if (isReports) {
                  bodyObj.fieldType = searchData?.fieldType ? searchData?.fieldType : '';
                }
                if (query && query.search.length) {
                  bodyObj.search = query.search;
                }
                queryRef.current = query;
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      setSubmit(false);
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;
                        const newObj = {};
                        if (selectedRows) {
                          [...selectedRows, ...tempSelectedRows].forEach((el) => {
                            if (!newObj[el.fieldName + el.repositoryName]) {
                              newObj[el.fieldName + el.repositoryName] = el;
                            }
                          });
                        }
                        if ((!isDataManager || !isDMRTrue) && dmValues) {
                          [...dmValues.selectedFields, ...tempSelectedRows].forEach((el) => {
                            if (!newObj[el.fieldName + el.repositoryName]) {
                              newObj[el.fieldName + el.repositoryName] = el;
                            }
                          });
                        }

                        if (isDMRTrue) {
                          [...dmValues.selectedFields, ...tempSelectedRows].forEach((el) => {
                            if (!newObj[el.fieldName + el.repositoryName + el.processorFieldType]) {
                              newObj[el.fieldName + el.repositoryName + el.processorFieldType] = el;
                            }
                          });
                        }
                        if (isDataManager && dmValues) {
                          [...dmValues.selectedFields, ...tempSelectedRows].forEach((el) => {
                            if (!newObj[el.fieldName + el.repositoryName + el.mapFieldType]) {
                              newObj[el.fieldName + el.repositoryName + el.mapFieldType] = el;
                            }
                          });
                        }
                        if (formulaFields) {
                          [...formulaFields, ...tempSelectedRows].forEach((el) => {
                            if (!newObj[el.fieldName + el.repositoryName]) {
                              newObj[el.fieldName + el.repositoryName] = el;
                            }
                          });
                        }
                        if (filterFields) {
                          [...filterFields, ...tempSelectedRows].forEach((el) => {
                            if (!newObj[el.fieldName + el.repositoryName]) {
                              newObj[el.fieldName + el.repositoryName] = el;
                            }
                          });
                        }
                        if (sortFields) {
                          [...sortFields, ...tempSelectedRows].forEach((el) => {
                            if (!newObj[el.fieldName + el?.repositoryName]) {
                              newObj[el.fieldName + el?.repositoryName] = el;
                            }
                          });
                        }
                        if (dateStampFields) {
                          [...dateStampFields, ...tempSelectedRows].forEach((el) => {
                            if (!newObj[el.fieldName + el?.repositoryName]) {
                              newObj[el.fieldName + el?.repositoryName] = el;
                            }
                          });
                        }
                        if (rules) {
                          [...tempSelectedRows].forEach((el) => {
                            if (!newObj[el.fieldName + el?.repositoryName]) {
                              newObj[el.fieldName + el?.repositoryName] = el;
                            }
                          });
                        }

                        if (setIntermediateField) {
                          [...tempSelectedRows, intermediateField].forEach((el) => {
                            if (!newObj[el.fieldName + el?.repositoryName]) {
                              newObj[el.fieldName + el?.repositoryName] = el;
                            }
                          });
                        }
                        const newData = data?.map((el) => {
                          return {
                            ...el,
                            mapFieldType: 'DB Field',
                            processorFieldType: 'DB Field',
                          };
                        });
                        const newRows =
                          (isDataManager && !exceptionType) || isDMRTrue
                            ? newData?.map((elem) => {
                              if (
                                newObj[elem.fieldName + elem.repositoryName + elem.mapFieldType]
                              ) {
                                return {
                                  ...elem,
                                  tableData: { ...elem.tableData, checked: true },
                                };
                              } else {
                                return {
                                  ...elem,
                                  tableData: { ...elem.tableData, checked: false },
                                };
                              }
                            })
                            : data?.map((elem) => {
                              if (newObj[elem.fieldName + elem.repositoryName]) {
                                return {
                                  ...elem,
                                  tableData: { ...elem.tableData, checked: true },
                                };
                              } else {
                                return {
                                  ...elem,
                                  tableData: { ...elem.tableData, checked: false },
                                };
                              }
                            });

                        let rows = [];
                        if (eventTrigger) {
                          const newObj = {};
                          if (selectedRepoField) {
                            [...selectedRepoField].forEach((el) => {
                              if (!newObj[el.fieldName + el.repositoryName]) {
                                newObj[el.fieldName + el.repositoryName] = el;
                              }
                            });
                          }
                          rows = data?.map((elem) => {
                            if (newObj[elem.fieldName + elem.repositoryName]) {
                              return { ...elem, tableData: { ...elem.tableData, checked: true } };
                            } else {
                              return {
                                ...elem,
                                tableData: { ...elem.tableData, checked: false },
                              };
                            }
                          });
                        }

                        resolve({
                          data:
                            eventTrigger && rows?.length > 0
                              ? rows
                              : isReports && newRows?.length > 0
                                ? newRows
                                : data.length > 0
                                  ? data
                                  : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(response.data.response.resultObject.length === 1);
                        setDataCount(response.data.response.count);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            // actions={
            //   !isReports
            //     ? [
            //       {
            //         icon: () => (
            //           <>
            //             <Button
            //               type="button"
            //               variant="outlined"
            //               className={`mx-1 search-btn`}
            //               disabled={!dataRepoAccess?.add}
            //             >
            //               Add Data Repository
            //             </Button>
            //           </>
            //         ),
            //         isFreeAction: true,
            //         disabled: !dataRepoAccess?.add,
            //         onClick: (event) => {
            //           dispatch(resetMsg());
            //           if (StepperFieldList) {
            //             setShowSearch(true);
            //           } else {
            //             setTabValue(1);
            //           }
            //         },
            //       },
            //       (rowData) => ({
            //         icon: () => <EditOutlinedIcon />,
            //         tooltip: "Edit",
            //         disabled: rowData?.repositoryType === "SYSTEM" || !dataRepoAccess?.edit,
            //         onClick: (event, rowData) => {
            //           if (rowData?.dataRepositoryId) {
            //             dispatch(fetchDataRepository(rowData?.dataRepositoryId));
            //             setRowSelected(rowData?.dataRepositoryId);
            //             if (!StepperFieldList) {
            //               setTabValue(1);
            //               setGlobalFieldRow(true);
            //             } else {
            //               setShowSearch(true);
            //             }
            //           }
            //         },
            //       }),
            //       // (rowData) => ({
            //       //   icon: () => <FileCopyOutlinedIcon />,
            //       //   tooltip: "Copy",
            //       //   disabled: true,
            //       //   hidden: rowData?.repositoryType === "SYSTEM",
            //       //   onClick: (event, rowData) => {
            //       //     setIsCopyData(true);
            //       //     dispatch(fetchDataRepository(rowData?.dataRepositoryId));
            //       //     setTabValue(1);
            //       //   },
            //       // }),
            //       (rowData) => ({
            //         icon: () => <DataUsageIcon className={classes.copyButtonroot} />,
            //         tooltip: "Usage",
            //         hidden: isReports,
            //         onClick: (event, rowData) => {
            //           setDeleteUsage(false);
            //           dispatch(fetchDataRepoUsage(rowData, "RepoField"));
            //           setFieldListRowData(rowData);
            //         },
            //       }),
            //       {
            //         icon: () => <DescriptionOutlinedIcon className={classes.copyButtonroot} />,
            //         tooltip: "Data Repository Notes",
            //         // hidden: reportMasterSearch,
            //         onClick: (event, rowData) => {
            //           setDataRepoRowData(rowData);
            //           setIsNote(true);
            //         },
            //       },
            //     ]
            //     : []
            // }
            options={{
              search: false,
              pageSize: rows,
              toolbar: !isReports,
              toolbarButtonAlignment: 'left',
              selection: isReports && !addAccountUpdate,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              showTextRowsSelected: false,
              selectionProps:
                eventTrigger || setIntermediateField
                  ? handleSelectionProps
                  : (rowData) => {
                    let disabledFields = false;
                    if (isDMTrue) {
                      selectedRows?.forEach((el) => {
                        if (
                          el.repositoryName.concat(el.fieldName) ===
                              rowData.repositoryName.concat(rowData.fieldName) &&
                            (el.type === 'Record' ||
                              el?.isEditable === false ||
                              el.type === 'Record Group')
                        ) {
                          disabledFields = true;
                        }
                      });
                    }
                    if (isDataManager && !exceptionType) {
                      dmValues?.selectedFields?.forEach((el) => {
                        if (
                          el.repositoryName.concat(el.fieldName).concat(el.mapFieldType) ===
                              rowData.repositoryName
                                .concat(rowData.fieldName)
                                ?.concat(rowData?.mapFieldType) &&
                            el.isEditable === false
                        ) {
                          disabledFields = true;
                        }
                      });
                    }
                    if (isDataManager && exceptionType) {
                      dmValues?.selectedFields?.forEach((el) => {
                        if (
                          el.repositoryName.concat(el.fieldName) ===
                              rowData.repositoryName.concat(rowData.fieldName) &&
                            el.mapFieldType === 'Record Field'
                        ) {
                          disabledFields = true;
                        }
                      });
                    }
                    if (isDMRTrue) {
                      dmValues?.selectedFields?.forEach((el) => {
                        if (
                          el.repositoryName
                            ?.concat(el.fieldName)
                            ?.concat(el?.processorFieldType) ===
                              rowData.repositoryName
                                ?.concat(rowData.fieldName)
                                ?.concat(rowData?.mapFieldType) &&
                            (el.tabType === 'Record Format Field' || el?.isEditable === false)
                        ) {
                          disabledFields = true;
                        }
                      });
                    }
                    const checked = rowData?.active === 'no' ? { checked: false } : {};
                    const selectedCategories = selectedRows?.map((each) => each?.category);
                    const disableCheckedFieldListC = selectedCategories?.includes('CL')
                      ? rowData.fieldName === 'CLIENT_NUMBER' &&
                          rowData.repositoryName === 'DB_ACCOUNT'
                        ? true
                        : false
                      : false;
                    const disableCheckedFieldListD = selectedCategories?.includes('CO')
                      ? rowData.fieldName === 'ACCOUNT_NUMBER' &&
                          rowData.repositoryName === 'DB_ACCOUNT'
                        ? true
                        : false
                      : false;
                    return {
                      disabled:
                          rowData?.active === 'no' || workQueue
                            ? rowData?.fieldName === 'ACCOUNT_NUMBER' &&
                              rowData?.repositoryName === 'DB_ACCOUNT'
                            : isGlobalFieldList
                              ? disableCheckedFieldListC || disableCheckedFieldListD
                              : isDataManager || isDMRTrue || isDMTrue
                                ? disabledFields
                                : false,
                      ...checked,
                    };
                  },
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              !isReports && {
                icon: () => <SaveIcon />,
                tooltip: 'Save User',
                onClick: (event, rowData) => console.log(rowData, 'rowData'),
              },
            ]}
            components={{
              Pagination: (props) => (
                // Added Download Configuration Buttons in Table Pagination (2700799562)
                <div className="global-field-table-footer pagination-block">
                  {/* letter we removed that one */}
                  {isReports && <div className="mt-2"></div>}
                  {!isReports && (
                    <div className="mt-2">
                      <Button
                        type="button"
                        variant="outlined"
                        className={`mx-1 search-btn`}
                        disabled={Boolean(dataCount === 0)}
                        onClick={(event) => {
                          dispatch(
                            postPrintUsage({
                              category: searchData?.category?.categoryCode
                                ? searchData.category?.categoryCode
                                : '',
                              fieldListOrderBy:
                                queryRef.current.orderBy && queryRef.current.orderBy.field
                                  ? queryRef.current.orderBy.field
                                  : '',
                              fieldListOrderDerection: queryRef.current?.orderDirection
                                ? queryRef.current?.orderDirection
                                : '',
                              createdBy: searchData?.createdBy?.userLoginName
                                ? searchData?.createdBy?.userLoginName
                                : '',
                              createdDate: searchData?.createdDate
                                ? moment(searchData?.createdDate).format('MM/DD/YYYY')
                                : '',
                              fieldName: searchData?.fieldName ? searchData.fieldName : '',
                              frameworkUsageOrderBy: order?.orderBy ? order?.orderBy : '',
                              frameworkUsageOrderDerection: order?.orderDirection
                                ? order?.orderDirection
                                : '',
                              repositoryName: searchData?.repoName ? searchData.repoName : '',
                              repositoryDescription: searchData?.repoDescription
                                ? searchData.repoDescription
                                : '',
                              repositoryType: searchData?.repoType?.repoTypeName
                                ? searchData?.repoType?.repoTypeName
                                : '',
                              sourceType: 'DATA REPOSITORY',
                              fieldDescription: searchData?.fieldDescription
                                ? searchData.fieldDescription
                                : '',
                              company: companyData.length > 0 ? companyData : [],
                            }),
                          );
                        }}
                      >
                        Download Configuration Usage
                      </Button>
                      <Button
                        type="button"
                        variant="outlined"
                        className={`mx-1 search-btn`}
                        disabled={Boolean(dataCount === 0)}
                        onClick={(event) => {
                          dispatch(
                            printDataRepositories({
                              category: searchData?.category?.categoryCode
                                ? searchData.category?.categoryCode
                                : '',
                              fieldName: searchData?.fieldName ? searchData.fieldName : '',
                              repositoryName: searchData?.repoName ? searchData.repoName : '',
                              repositoryDescription: searchData?.repoDescription
                                ? searchData.repoDescription
                                : '',
                              repositoryType: searchData?.repoType?.repoTypeName
                                ? searchData?.repoType?.repoTypeName
                                : '',
                              orderBy:
                                queryRef.current.orderBy && queryRef.current.orderBy.field
                                  ? queryRef.current.orderBy.field
                                  : '',
                              orderDirection: queryRef.current?.orderDirection
                                ? queryRef.current?.orderDirection
                                : '',
                              createdBy: searchData?.createdBy?.userLoginName
                                ? searchData?.createdBy?.userLoginName
                                : '',
                              createdDate: searchData?.createdDate
                                ? moment(searchData?.createdDate).format('MM/DD/YYYY')
                                : '',
                              company: companyData.length > 0 ? companyData : [],
                              printIndividual: 'N',
                              fieldsSearch: 'N',
                              fieldDescription: searchData?.fieldDescription
                                ? searchData.fieldDescription
                                : '',
                            }),
                          );
                        }}
                      >
                        {downloadButton}
                      </Button>
                    </div>
                  )}
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: { 'aria-label': 'Rows per screen' },
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
              Action: (props) => (
                <ActionMenuItem
                  {...props}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  handleNotes={handleNotes}
                  handleUsage={handleUsage}
                  hiddenMenu={{
                    edit: false,
                    run: true,
                    copy: true,
                    hiddenDelete: true,
                    notes: false,
                    execution: true,
                    usage: isReports,
                    user: true,
                    password: true,
                    test: true,
                  }}
                  disableMenu={{
                    disableEdit: props?.data?.repositoryType === 'SYSTEM' || !dataRepoAccess?.edit,
                    disableRun: false,
                    disableCopy: false,
                    disableDelete: false,
                    disableNotes: false,
                    disableExecution: false,
                    disableUsage: false,
                    disableUser: false,
                    disablePassword: false,
                    disableTest: false,
                  }}
                />
              ),
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div>
                    {/* {mapRecord && ( */}
                    <Button
                      type="button"
                      variant="outlisetOpenned"
                      className={`mx-1 search-btn`}
                      disabled={!dataRepoAccess?.add}
                      isFreeAction={true}
                      onClick={(event) => {
                        dispatch(resetMsg());
                        if (StepperFieldList) {
                          setShowSearch(true);
                        } else {
                          setTabValue(1);
                        }
                      }}
                      startIcon={<AddIcon />}
                    >
                      Add Data Repository
                    </Button>
                    {/* )} */}
                  </div>
                </div>
              ),
            }}
            onRowClick={(event, rowData) => {
              if (addAccountUpdate) {
                setSelectedGlobalField(rowData);
                handleEventTacticSearch(false);
              }
            }}
          />
        </div>
        {isLoadingPrint && <PageLoader />}
        {customError && (
          <WarningSnackbar errorMsg={'This Data Repository is not being used anywhere'} />
        )}
        {(errorMsg || deleteErrorMsg || printusage?.errorMsg) && (
          <ErrorSnackbar errorMsg={errorMsg || printusage?.errorMsg || deleteErrorMsg} />
        )}
        {(successMsg || printusage?.successMsg || tstmsg) && (
          <SuccessSnackbar successMsg={successMsg || printusage?.successMsg || tstmsg} />
        )}
      </Grid>
    </>
  );
};

export default React.memo(FieldListSearchTable);
